
import useSWR from 'swr';
import { fetcher } from '../index';

export default function useArticles() {
	const { data, error } = useSWR('/api/v1/sales/campaigns/articles', fetcher);
	return {
		articles: data,
		isLoading: !data && !error,
		error: error
	};
}
